module.exports = __webpack_public_path__ + "static/media/background.9943e04e.jpg";